var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-wrapper"},[_c('card',{scopedSlots:_vm._u([{key:"searchBody",fn:function(){return [_c('b-row',[_c('b-col',{attrs:{"xs":"12","sm":"12","md":"4","lg":"4","xl":"4","offset":"1"}},[_c('p',[_vm._v("Welcome to RJSC Dashboard")])])],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }